import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { verifyAPI } from "../../../config/api/apiConfig";
import { v4 as uuid } from "uuid";

const isTokenExpired = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  const payload = JSON.parse(atob(base64));

  console.log(payload);
  console.log("TOKEN TIME", payload.exp);

  // Implement your own logic to check if the token is expired
  const currentTimestamp = Math.floor(Date.now() / 1000);
  console.log("CURRENT TIME", currentTimestamp);
  return payload.exp < currentTimestamp;
};


export const verifyUser = createAsyncThunk(
  "authenticate/verifyUser",
  async (_, { getState }) => {
    const { token } = getState().authenticate;
    try {
      if (token) {
        const tokenResp = await verifyAPI("/verify-token", token);

        return tokenResp;
      }
    } catch (err) {
      //Use the access token in your API requests
      console.log("LOGIN ERROR", err);
      throw err;
    }
  }
);

const authSlice = createSlice({
  name: "authenticate",
  initialState: {
    userData: {},
    isLoggedIn: false,
    canLogIn: false,
    token: "",
    role: "",
    userId: null,
    username: "",
    organisationName: "",
    createdBy: -11,
    userToken: null,
    fullName: "",
  },
  reducers: {
    setIsloggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setCanLogIn: (state, action) => {
      state.canLogIn = action.payload;
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setOrganisationName: (state, action) => {
      state.organisationName = action.payload;
    },
    setCreatedBy: (state, action) => {
      state.createdBy = action.payload;
    },
    setUserToken: (state, action) => {
      state.userToken = action.payload;
    },
    setFullName: (state, action) => {
      state.fullName = action.payload;
    },
    resetState: (state) => {
      // Reset the state to its initial values
      state.userId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyUser.fulfilled, (state, action) => {
        state.userData = action.payload;
        state.isLoading = false;
      })
      .addCase(verifyUser.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const {
  setIsloggedIn,
  setToken,
  setCanLogIn,
  setRole,
  setUserId,
  setUsername,
  setOrganisationName,
  setCreatedBy,
  setUserToken,
  setFullName,
  resetState,
} = authSlice.actions;
export { authSlice };
export default authSlice.reducer;
